export function StringList({
	data,
	info,
	fallback,
	className,
}: {
	data?: string[];
	info?: { code: string; name: string }[];
	fallback?: string;
	className?: string;
}) {
	if (!data?.length) return <div className={className}>{fallback}</div>;

	return (
		<div className={className}>
			{data.map(d => (
				<div key={d}>{info?.find(i => i.code === d)?.name || d}</div>
			))}
		</div>
	);
}
